export default __webpack_public_path__ + "aabc7b9.png";